import React, { useContext } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// import MonsterWindow from './components/MonsterWindow/MonsterWindow'
// import Saves from './components/Saves/Saves'
// import Other from './components/Other/Other'
import Header from './components/Header/Header'
import Menu from './components/Menu/Menu'
// import Cards from './components/Cards/Cards'
// import $ from 'jquery'

import { CharacterProvider } from './contexts/character'
import { SubStatsProvider } from './contexts/subStats'
import { DBProvider } from './contexts/databases'

import { UIContext } from './contexts/ui'

import './app.scss'
import './sb-admin-2.css'

//only for test all the items scripts
// import Tests from './components/Tests/Tests'

import Simulator from './pages/Simulator'
import EXPScaler from './pages/EXPScaler'
import Refine from './pages/Refine'
import PatchNote from './pages/PatchNote'
import Contact from './pages/Contact'
import About from './pages/About'

function App(props) {
	const { Theme } = useContext(UIContext)
	return (
		<div className='mainContainer'>
			<DBProvider>
				<CharacterProvider>
					<SubStatsProvider>
						<React.StrictMode>
							<BrowserRouter>
								<Menu />
								<div className={'mainPage mainBGColor' + Theme}>
									<Header />
									<Routes>
										<Route
											path='/expscaler'
											element={<EXPScaler />}
										/>
										<Route
											path='/refine'
											element={<Refine />}
										/>
										<Route
											path='/news'
											element={<PatchNote />}
										/>
										<Route
											path='/contact'
											element={<Contact />}
										/>
										<Route
											path='/about'
											element={<About />}
										/>
										<Route
											path='*'
											element={<Simulator />}
										/>
									</Routes>
								</div>
							</BrowserRouter>
						</React.StrictMode>
					</SubStatsProvider>
				</CharacterProvider>
			</DBProvider>
		</div>
	)
}

export default App
